import type { ViewConfigSheetPreset } from '@salescore/core'
import type { ModalFuncProps } from 'antd'
import { t } from 'i18next'

import type { SalescoreObjectAbility, ViewAbility } from '../../../../recoil/view/atoms'
import { SheetPresetForm } from './SheetPresetForm'

export const buildSheetPresetFormModalProperties = ({
  preset,
  onAfterFinish,
  ability,
}: {
  preset: ViewConfigSheetPreset | undefined
  onAfterFinish: () => void
  ability: ViewAbility & SalescoreObjectAbility
}): ModalFuncProps => {
  const isNew = preset === undefined
  const title = t(`プリセットの{{title}}`, { title: isNew ? t(`新規作成`) : t(`編集`) })

  return {
    icon: null,
    title,
    width: '90%',
    closable: true,
    maskClosable: true,
    destroyOnClose: true,
    footer: null,
    content: <SheetPresetForm preset={preset} onAfterFinish={onAfterFinish} ability={ability} />,
  }
}
